import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"28px","text-align":"center","font-weight":"bold","margin-bottom":"32px"} }, " 个案处理摘要 ", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"26px","border":"2px dashed #c0bec7","margin-top":"32px","padding":"24px 32px"} }, " 根据个案处理摘要显示，“性别”中“男”的个案数为10个，有效百分比为47.62%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为10个，总计个案数百分比为100.00%；“性别”中“女”的有效个案数为11个，有效百分比为52.38%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为11个，总计个案数百分比为100.00%；“年龄”中“18-30岁”的个案数为6个，有效百分比为28.57%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为6个，总计个案数百分比为100.00%，“年龄”中“31-40岁”的有效个案数为8个，有效百分比为38.10%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为8个，总计个案数百分比为100.00%，“年龄”中“41岁以上”的有效个案数为7个，有效百分比为33.33%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为7个，总计个案数百分比为100.00%。 ", -1)


import { useTable } from '../../../hooks/use-table';

const className = 'case-table-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-case-3',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;

const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", { innerHTML: _unref(html) }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})